import List from './List';
import Td from './Td';
import Th from './Th';
import Tr from './Tr';

export default {
  List,
  Td,
  Th,
  Tr
};
